"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Arrow constants
var FULL_RES_ARROW_WIDTH = exports.FULL_RES_ARROW_WIDTH = 14;
var FULL_RES_ARROW_HEIGHT = exports.FULL_RES_ARROW_HEIGHT = 12;
var FULL_RES_STROKE_WIDTH = exports.FULL_RES_STROKE_WIDTH = 2;

// The arrow is scaled based on the stroke width (because the markerUnits are strokeWidth)
// so divide by the stroke width to get the actual units.
var ARROW_WIDTH_UNITS = exports.ARROW_WIDTH_UNITS = FULL_RES_ARROW_WIDTH / FULL_RES_STROKE_WIDTH;
var ARROW_HEIGHT_UNITS = exports.ARROW_HEIGHT_UNITS = FULL_RES_ARROW_HEIGHT / FULL_RES_STROKE_WIDTH;

// Line constants
var LINE_HIT_AREA = exports.LINE_HIT_AREA = 20;
var INSET = exports.INSET = LINE_HIT_AREA / 2;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/lineUiConstants.js
// module id = 738
// module chunks = 0